export const asCanvas = (canvas) => Promise.resolve(canvas);
